var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-4"},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"page-title mt-2"},[_vm._v("Mentions légales")]),_c('hr')])],1),_c('b-row',[_c('app-content',{attrs:{"slug":"rgpd"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }